import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { LookupService } from '../../../shared/services/lookup.service';
import { TransactionListService } from '../shared/services/transaction-list.service';
import { TransactionEditSubmitDataModel } from '../shared/models/transaction-edit-submit-data-model';
import { TransactionPayerCustomerModel } from '../shared/models/transaction-payer-customer-model';
import { TransactionListItemModel } from '../shared/models/transaction-list-item-model';
import { PaymentMethod } from '../shared/models/payment-method';
import { CommonLookupItem } from '../../../shared/models/common-lookup-item.model';
import { SelectItem } from 'primeng/api';
import { TransactionApprovalStatus } from '@admin/billing/transactions/shared/models/transaction-approval-status';
import { ActionResultModel } from '../../../shared/models/action-result-model';
import { TranslateService } from '@ngx-translate/core';
import { TransactionOptionItem } from '../shared/models/transaction-list-filter.model';

@Component({
  selector: 'hr-transaction-edit',
  templateUrl: './transaction-edit.component.html',
  styleUrls: ['./transaction-edit.component.less'],
  standalone: false,
})
export class TransactionEditComponent implements OnInit, OnChanges {
  @Input()
  public transaction: TransactionListItemModel;
  @Input()
  public display: boolean;

  public transactionApprovalStatusEnum = TransactionApprovalStatus;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['transaction'] && changes['transaction'].currentValue != null) {
      this.initData();
    }
  }

  public editSubmitData: TransactionEditSubmitDataModel;
  public payersList: TransactionOptionItem[];

  public paymentMethods: SelectItem[];

  constructor(
    private lookupService: LookupService,
    private translationService: TranslateService,
    private transactionService: TransactionListService
  ) {
    this.editSubmitData = new TransactionEditSubmitDataModel();
    this.editSubmitData.invoiceAmount = 0;
    this.editSubmitData.paymentType = 0;
    this.editSubmitData.transactionRecordId = 0;
    this.editSubmitData.payerAccount = { id: -1, label: '' };
    this.payersList = [];
  }

  @Output()
  public onUpdate: EventEmitter<ActionResultModel> =
    new EventEmitter<ActionResultModel>();

  public onCancel() {
    let result = new ActionResultModel();
    result.success = false;
    this.onUpdate.emit(result);
  }

  public onSave() {
    this.transactionService
      .editTransaction(this.editSubmitData)
      .subscribe((r) => {
        this.onUpdate.emit(r);
      });
  }

  public filterPayer(event) {
    this.transactionService.listPayers(event.query).subscribe((l) => {
      this.payersList = l?.map((v) => {
        return {
          id: v.value,
          label: v.text,
        };
      });
    });
  }

  public initData() {
    this.editSubmitData.transactionRecordId =
      this.transaction.transactionRecordId;
    this.editSubmitData.invoiceAmount = this.transaction.invoiceTotalAmount;
    this.editSubmitData.paymentType = this.transaction.paymentMethodId;

    this.editSubmitData.payerAccount.id = this.transaction.payerAccountId;
    this.editSubmitData.payerAccount.label = this.transaction.payerName;
  }

  ngOnInit() {
    this.paymentMethods = [
      {
        label: this.translationService.instant('label.Barter'),
        value: PaymentMethod.Barter,
      },
      {
        label: this.translationService.instant('label.CreditPaid'),
        value: PaymentMethod.CreditPaid,
      },
      {
        label: this.translationService.instant('label.Internal'),
        value: PaymentMethod.Internal,
      },
    ];
  }
}
